// extracted by css-extract-rspack-plugin
export default {"inputWrapper":"Wa8B5e4_qyoZvsz0","adornmentOverlay":"ai_47v75KjIfZeMp","ghostValue":"LptB1RbxXggvFvaS","adornment":"sejVH79iCewgdcvo"};